<template>
  <BlSheetChildPage id="sheet-location" style="margin: 0 auto" class="max-w-[480px]" title="Lokasi" @close="onClose">
    <div class="relative">
      <div class="sticky z-40 bg-white top-0">
        <BlNavBarSearchMv data-testid="location-search" placeholder="Cari lokasi" @input="handleSearch" />
      </div>
      <div class="ph-16" style="overflow-y: scroll; height: 60vh">
        <div v-for="(location, index) in filteredLocations" :key="location.name" class="block p-4">
          <BlCheckboxAv
            :id="`loc-check-${index + 1}`"
            v-model="selectedLocations"
            data-testid="location-checkbox"
            :native-value="location.name"
            class="u-width-1 pv-4"
          >
            {{ location.name }}
          </BlCheckboxAv>
        </div>
      </div>
      <div slot="footer" :class="footerClasses">
        <BlButtonAv id="ut-location-trigger" type="submit" variation="primary" fullwidth @click="onSubmit">Terapkan</BlButtonAv>
      </div>
    </div>
  </BlSheetChildPage>
</template>

<script>
import {mapGetters} from 'vuex';
import {sortBy} from 'lodash';
import {BlButtonAv, BlCheckboxAv, BlNavBarSearchMv} from '@bukalapak/bazaar-mweb-latest';
import BlSheetChildPage from '../shared/BlSheetChildPage.vue';
import prakerjaFilterMixin from '../../mixins/prakerja-filter-mixin';

const DUPLICATE_PROVINCE_CITY = ['Gorontalo', 'Jambi', 'Bengkulu'];
const CITY_KEY = 'city';
const PROVINCE_KEY = 'province';

export default {
  name: 'PrakerjaCoursesLocation',
  components: {
    BlSheetChildPage,
    BlButtonAv,
    BlCheckboxAv,
    BlNavBarSearchMv,
  },
  mixins: [prakerjaFilterMixin],
  data() {
    return {
      showButton: false,
      locations: [],
      filteredLocations: [],
      selectedLocations: [],
    };
  },
  computed: {
    ...mapGetters('courses', ['getProvincesFilter', 'getCitiesFilter']),
    isLocationSelected() {
      return this.selectedLocations.length > 0;
    },
    footerClasses() {
      let baseClass = 'p-16 border-t border-[#F1F2F5]';

      return this.showButton ? 'sticky bottom-0 bg-white ' + baseClass : `${baseClass} hidden`;
    },
  },
  watch: {
    selectedLocations() {
      this.showButton = true;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$api.getAddress().then(({data}) => {
        const provinces = [
          ...Object.keys(data).map((province) => ({
            name: DUPLICATE_PROVINCE_CITY.includes(province) ? `Provinsi ${province}` : province,
            type: PROVINCE_KEY,
          })),
        ];
        let cities = [];

        Object.values(data).forEach((city) => {
          Object.keys(city).forEach((key) => {
            let name = key;
            if (DUPLICATE_PROVINCE_CITY.includes(key)) {
              name = `Kota ${key}`;
            }
            cities.push({
              name,
              type: CITY_KEY,
            });
          });
        });

        this.locations = sortBy([...provinces, ...cities], (object) => object.name);
        this.filteredLocations = this.locations;
        this.setDefaultFilter();
      });
    },
    setDefaultFilter() {
      if (this.getProvincesFilter.length < 1 && this.getCitiesFilter.length < 1) return;

      const parsedProvinces = this.getProvincesFilter.map((province) => {
        return DUPLICATE_PROVINCE_CITY.includes(province) ? `Provinsi ${province}` : province;
      });
      const parsedCities = this.getCitiesFilter.map((province) => {
        return DUPLICATE_PROVINCE_CITY.includes(province) ? `Kota ${province}` : province;
      });
      this.selectedLocations = [...parsedProvinces, ...parsedCities];
      this.filteredLocations = sortBy(this.locations, (location) => (this.selectedLocations.includes(location.name) ? 0 : 1));
    },
    handleSearch(val) {
      this.filteredLocations = this.locations.filter((location) => location.name.toLowerCase().includes(val.toLowerCase()));
    },
    onSubmit() {
      let locations = {
        cities: [],
        provinces: [],
      };

      if (this.isLocationSelected) {
        const locationsObject = this.locations.filter((location) => this.selectedLocations.includes(location.name));
        const cities = locationsObject.filter((location) => location.type === CITY_KEY).map((city) => city.name.replace('Kota ', '')); // remove appended string
        const provinces = locationsObject
          .filter((location) => location.type === PROVINCE_KEY)
          .map((province) => province.name.replace('Provinsi ', ''));
        locations = {
          cities,
          provinces,
        };
      }

      this.$store.commit('courses/setCoursesFilter', locations);
      this.$store.commit('courses/resetCourses');
      this.$store.dispatch('courses/fetchCourses');

      this.onClose();
    },
  },
};
</script>
